export default __webpack_public_path__ + "static/media/booking3.fb6eeae8.png";